const templ = require('sma.admin/components/partials/loader.mustache');

class Loader {
	constructor(element, size, options) {
		this.element = $(element);

		let isTranslated = false;
		if (options !== undefined) {
			isTranslated = options.isTranslated;
		}

		this.loader = $(templ(
			{
				size: size,
				isTranslated: isTranslated
			},
		));

		this.element.prepend(this.loader);
	}

	show() {
		this.loader.show();
	}

	hide() {
		this.loader.hide();
	}
}

module.exports = Loader;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.admin/components/loader.js